<template lang='pug'>
  .container
    .container
      .row.mt-5.align-items-center
        .col-12.my-header.font-weight-bold
            | GuestStore

    .container.mt-5
      .white_block          

</template>
<script>
var apiDriver = require("../../apiDriver").default;

export default {
  data() {
    return {};
  },

  computed: {},

  mounted() {
    this.checkConnectionQuery();
    this.loadContacts();
  },

  methods: {}
};
</script>
<style scoped lang="stylus">
.white_block {
  background: white;
  margin: 5px;
  padding: 10px 20px;
  border-radius: 4px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  margin-bottom: 7px;
}

.my-header {
  font-size: 3.5rem;
}

.header-sub {
  // color: white;
  font-size: 1.5rem;
}

button.styled, a.styled {
  margin-bottom: 5px;
  border: 1px solid #6c68cb;
  padding: 10px 15px;
  border-radius: 4px;
  color: #464384;
  cursor: pointer;

  &:hover {
    background: #6c68cb;
    color: white;
  }

  &[disabled] {
    border-color: #ddd;
    color: #ddd;
    cursor: default;
    background: white;
  }

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
